import { useEffect } from "react";
import { LoadingScreen } from "@/core/RequireAuth";

/** Kilépés az SPA-ból egy publikus (SSR) oldalra — teljes oldalbetöltéssel.
 *  A `/konyv-melleklet` QR-URL tartaléka: rendes esetben már az edge nginx átirányít. */
export function PublicRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <LoadingScreen />;
}
